export const UPDATE_AUTH = 'UPDATE_AUTH';
export const TOGGLE_LOGIN_MODAL = 'TOGGLE_LOGIN_MODAL';
export const FETCH_REQUEST_AUTH = 'FETCH_REQUEST_AUTH';
export const FETCH_AUTH_SUCCESS = 'FETCH_AUTH_SUCCESS';
export const FETCH_AUTH_ERROR = 'FETCH_AUTH_ERROR';
export const REQUEST_LOGOUT = 'REQUEST_LOGOUT';
export const REQUEST_LOGOUT_ERROR = 'REQUEST_LOGOUT_ERROR';
export const REQUEST_LOGOUT_SUCCESS = 'REQUEST_LOGOUT_SUCCESS';
export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const REQUEST_LOGIN_ERROR = 'REQUEST_LOGIN_ERROR';
export const REQUEST_LOGIN_SUCCESS = 'REQUEST_LOGIN_SUCCESS';
export const CLEAR_LOGIN_ERRORS = 'CLEAR_LOGIN_ERRORS';